import { Button, Input, Space } from "antd";
import { ChangeEvent, useState } from "react";
import { retrieveLaunchParams } from "@telegram-apps/sdk";
import { API } from "../api";
import { isTelegramWebApp } from "../utils";
import { LaunchParams } from "@telegram-apps/sdk-react";

export const Login = () => {
  const [agencyId, setAgencyId] = useState("");
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const handleAgencyId = (event: ChangeEvent<HTMLInputElement>) => {
    setAgencyId(event.target.value.trim());
  };

  const handlePassword = (event: ChangeEvent<HTMLInputElement>) => {
    setText(event.target.value.trim());
  };

  const submit = async () => {
    const { initData } = isTelegramWebApp() ? retrieveLaunchParams() : {} as LaunchParams;

    try {
      const data = await API.login({
        agency_id: agencyId ? agencyId : undefined,
        password: text,
        telegram: initData?.user?.id,
        telegram_username: initData?.user?.username
      });

      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("cleaner_id", data.cleaner_id);
        window.location.reload();
      } else {
        setError("Не нашли вас");
      }
    } catch {
      setError('Неправильный логин или пароль');
    }
  };

  return (
    <div className="vertical">
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        { !isTelegramWebApp() && <div>Введите номер РК</div> }
        { !isTelegramWebApp() && <Input type="text" size="large" onChange={handleAgencyId} />}
        <div>Введите пароль, который вам прислал менеджер</div>
        <Input type="password" size="large" onChange={handlePassword} />
        <Button size="large" style={{ width: "100%" }} type="primary" onClick={submit}>
          Войти
        </Button>
        {error && <div>{error}</div>}
      </Space>
    </div>
  );
};
